import React, { useState, useEffect, useContext } from "react";

import {
  Card,
  Grid,
  IconButton,
  FormControl,
  TextField,
  MenuItem,
  Button,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
import { makeStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LocalConvenienceStoreOutlined } from "@material-ui/icons";
// import { ArrowUpwardSharp } from '@material-ui/icons';
import feedbackContext from "contexts/feedbackContext";
import { notify, closeSnack } from "utils/MyFunctions";
import FileUpload from "../../../../FileUpload";
import UserContext from "contexts/userContext";

export default function LivePreviewExample(props) {
  const intl = useIntl();
  const { role, setRole, locale } = useContext(UserContext);
  const [file, setFile] = useState();
  const [init, setInit] = useState([]);
  const [files, setFiles] = useState([]);
  const [fch, setFch] = useState([]);
  const [b64files, setB64Files] = React.useState([]);
  const [valid, setValid] = useState(false);
  const { feedback, setFeedback, enqueueSnackbar, closeSnackbar } = useContext(
    feedbackContext,
  );

  // const ftypes = [
  //   'Document de référence',
  //   'Facture Commerciale',
  //   'Facture Fret',
  //   "Déclaration d'Importation",
  //   ''
  // ];

  const [ftypes, setFtypes] = React.useState([
    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_ref",
      ),
      selected: "false",
      at: null,
    },
    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_commercial",
      ),
      selected: "false",
      at: null,
    },
    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_fret",
      ),
      selected: "false",
      at: null,
    },
    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_packing_list",
      ),
      selected: "false",
      at: null,
    },

    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_certificate_origin",
      ),
      selected: "false",
      at: null,
    },
    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_special_authorization",
      ),
      selected: "false",
      at: null,
    },

    {
      name: formatMessage(
        intl,
        "create_besc_maritime_import_accordion_files_select_other",
      ),
      selected: "false",
    },
  ]);

  useEffect(() => {
    console.log("ftypes : ", ftypes);
    if (props.sens === "regule" && ftypes.length > 0) {
      console.log("HEY FTYPES, sense is regule");
      console.log("checking if the doc is there...");
      let _ex = ftypes.findIndex(
        (el) =>
          el.name ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_exoneration",
          ),
      );
      if (_ex > -1) {
        //DO NOTHING
      } else {
        let _ftypes = [...ftypes];
        console.log("adding exo doc");
        _ftypes.splice(_ftypes.length - 1, 0, {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_exoneration",
          ),
          selected: "false",
        });
        console.log("new ftypes : ", _ftypes);
        setFtypes(_ftypes);
      }
    }
    if (props.sens === "export") {
      let _ftypes = [...ftypes];
      console.log("old ftypes : ", _ftypes);
      //AJOUT DU DOCUMENT D'EXO d'abord
      console.log("checking if the doc is there...");
      let _ex = ftypes.findIndex(
        (el) =>
          el.name ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_exoneration",
          ),
      );
      if (_ex > -1) {
        //DO NOTHING
      } else {
        console.log("adding exo doc");
        _ftypes.splice(_ftypes.length - 1, 0, {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_exoneration",
          ),
          selected: "false",
        });
        console.log("new ftypes (1st step) : ", _ftypes);
      }

      //LA SUITE
      console.log("adding packing cert doc");
      _ftypes.splice(_ftypes.length - 1, 0, {
        name: formatMessage(
          intl,
          "create_besc_maritime_import_accordion_files_select_packing_certificate",
        ),
        selected: "false",
      });
      _ftypes.splice(_ftypes.length - 1, 0, {
        name: formatMessage(
          intl,
          "create_besc_maritime_import_accordion_files_select_vgm",
        ),
        selected: "false",
      });
      console.log("new ftypes(final) : ", _ftypes);
      setFtypes(_ftypes);
    }
  }, []);
  useEffect(() => {
    console.log("ftypes changed, ftypes : ", ftypes);
  }, [ftypes]);

  useEffect(() => {
    console.log("init : ", init);
  }, [init]);

  useEffect(() => {
    console.log("files : ", files);
    if (file) {
      console.log("file changed, file : ", file);
      let _values = [...files];
      let _fch = [...fch];
      _fch[file.index] = file.file.uuid;
      _values[file.index]["nom"] = file.file.name;

      let _b64files = [...b64files];
      _b64files[file.index] = file.file.uuid;

      setB64Files(_b64files);
      setFiles(_values);
      setFch(_fch);
    }
  }, [file]);

  useEffect(() => {
    console.log("files : ", files);
  }, [files]);

  useEffect(() => {
    console.log("b64files : ", b64files);
  }, [b64files]);

  useEffect(() => {
    console.log("fch : ", fch);
  }, [fch]);
  useEffect(() => {
    console.log("props data (FILES) changed, props data : ", props.data);
    if (Object.keys(props.data).length > 0) {
      setFiles(props.data);
      let _init = [...init];
      for (const [index, f] of props.data.entries()) {
        _init.push({
          index: index,
          name: f.nom,
        });
      }
      console.log("setting init to : ", _init);
      setInit(_init);
      if (fch.length == 0) {
        setFch(new Array(Object.keys(props.data).length));
      }

      setFtypes([
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_ref",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_ref",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_commercial",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_commercial",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_fret",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_fret",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_packing_list",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_packing_list",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_packing_certificate",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_packing_certificate",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_vgm",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_vgm",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_certificate_origin",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_certificate_origin",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_special_authorization",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_special_authorization",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_exoneration",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_exoneration",
              ),
          )).toString(),
          at: null,
        },
        {
          name: formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_other",
          ),
          selected: (!!props.data.find(
            (obj) =>
              obj.types ===
              formatMessage(
                intl,
                "create_besc_maritime_import_accordion_files_select_other",
              ),
          )).toString(),
        },
      ]);
    }
  }, [props.data]);

  useEffect(() => {
    let form = document.getElementById("file-form");
    let validity = false;
    let empot = false;

    validity = files.length == 0 ? false : form.checkValidity();
    let rdoc = false;
    let fret = false;
    let comm = false;
    let spec = false;
    let vgm = false;

    for (const fil of files) {
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_packing_certificate",
          ) &&
        fil.nom !== ""
      ) {
        console.log("setting empot true");
        empot = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_vgm",
          ) &&
        fil.nom !== ""
      ) {
        console.log("setting vgm true");
        vgm = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_ref",
          ) &&
        fil.nom !== ""
      ) {
        rdoc = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_commercial",
          ) &&
        fil.nom !== ""
      ) {
        comm = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_fret",
          ) &&
        fil.nom !== ""
      ) {
        fret = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_special_authorization",
          ) &&
        fil.nom !== ""
      ) {
        spec = true;
      }
    }

    console.log("empot is : ", empot);
    console.log(`rdoc is ${rdoc} comm is ${comm} fret is ${fret}`);
    console.log(`props conditionnement is ${props.conditionnement}`);
    console.log(
      `consignataire is ${role &&
        role.user &&
        role.user.company.consignataire}`,
    );
    console.log(`props conditionnement is ${props.conditionnement}`);

    console.log(
      `all expression is ${rdoc &&
        comm &&
        fret &&
        ((role && role.user && role.user.company.consignataire) ||
          ![
            "Chargeur Principal",
            "Sous Compte Chargeur",
            "Chargeur Secondaire",
          ].includes(role.user.roles[0].name) ||
          props.conditionnement !== "ro-ro" ||
          spec)}`,
    );

    if (props.sens === "export") {
      fret = true;
    }

    if (props.sens === "transit") {
      comm = true;
    }

    validity =
      rdoc &&
      comm &&
      fret &&
      ((role && role.user && role.user.company.consignataire) ||
        ![
          "Chargeur Principal",
          "Sous Compte Chargeur",
          "Chargeur Secondaire",
        ].includes(role.user.roles[0].name) ||
        props.conditionnement !== "ro-ro" ||
        spec);
    validity =
      props.sens === "export"
        ? validity && (props.conditionnement !== "conteneur" || empot)
        : validity;
    console.log("just set validity to : ", validity);

    console.log("setting files validity to : ", validity);
    console.log("empot is : ", empot);
    setValid(validity);
    props.setValidity(validity);

    if (validity || props.sens.toLowerCase() === "export") {
      props.sendFichiers(files);
      props.sendFch(fch);
      props.sendB64(b64files);
    }
  }, [files, props.conditionnement]);

  useEffect(() => {
    let spec = false;
    let empot = false;
    let vgm = false;
    for (const fil of files) {
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_packing_certificate",
          ) &&
        fil.nom !== ""
      ) {
        empot = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_special_authorization",
          ) &&
        fil.nom !== ""
      ) {
        spec = true;
      }
      if (
        fil.types ===
          formatMessage(
            intl,
            "create_besc_maritime_import_accordion_files_select_vgm",
          ) &&
        fil.nom !== ""
      ) {
        vgm = true;
      }
    }

    if (props.sens !== "export" && props.conditionnement === "ro-ro" && !spec) {
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_files_alert_fill_special_authorization",
        ),
        "warning",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
    }
    if (
      props.sens === "export" &&
      props.conditionnement === "conteneur" &&
      !empot
    ) {
      notify(
        formatMessage(
          intl,
          "create_besc_maritime_import_accordion_files_alert_fill_packing_certificate",
        ),
        "warning",
        "center",
        "bottom",
        true,
        enqueueSnackbar,
      );
    }
    // if (
    //   props.sens === "export" &&
    //   props.conditionnement === "conteneur" &&
    //   !vgm
    // ) {
    //   notify(
    //     formatMessage(
    //       intl,
    //       "create_besc_maritime_import_accordion_files_alert_fill_vgm"
    //     ),
    //     "warning",
    //     "center",
    //     "bottom",
    //     true,
    //     enqueueSnackbar
    //   );
    // }
  }, [props.conditionnement]);

  useEffect(() => {
    props.sendFch(fch);
  }, [fch]);

  const handleChange = (index, event) => {
    event.persist(event);

    let _values = [...files];
    _values[index][event.target.name] = event.target.value;

    setFiles(_values);
    if (
      event.target.name === "types"
      // && event.target.value !== "Autre"
    ) {
      let _ftypes = [...ftypes];
      let el = _ftypes.find((el) => el.name === event.target.value);

      el.selected = "true";
      el.at = index;

      setFtypes(_ftypes);
    }
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // const uploadFile = async (index, event) => {
  //   const filenames = event.target.files;

  //   if (filenames[0].size > 2 * 1048576) {
  //     // 1 MB in bytes
  //     notify(
  //       formatMessage(
  //         intl,
  //         "create_besc_maritime_import_accordion_files_alert_file_size"
  //       ),
  //       "info",
  //       "center",
  //       "bottom",
  //       true,
  //       enqueueSnackbar
  //     );
  //     event.target.value = ""; // clear the file input
  //   } else {
  //     // Handle the file upload logic here
  //     const fileName = filenames[0].name;

  //     let _values = [...files];
  //     let _fch = [...fch];
  //     _fch[index] = filenames[0];
  //     _values[index]["nom"] = fileName;

  //     let _b64files = [...b64files];
  //     _b64files[index] = await convertBase64(filenames[0]);

  //     setB64Files(_b64files);
  //     setFiles(_values);
  //     setFch(_fch);
  //   }
  // };

  const addFile = () => {
    let _values = [...files];
    _values.push({
      types: "",
      nom: "",
    });
    setFiles(_values);
  };

  const removeFile = (_index) => {
    //resetting selected to false
    let _ftypes = [...ftypes];
    let el = _ftypes.find((el) => el.name === files[_index]["types"]);

    if (el) {
      el.selected = "false";
    }

    setFtypes(_ftypes);
    //deleting value
    let _values = [...files];
    let _fch = [...fch];
    let _b64 = [...b64files];

    _values = _values.filter((value, index) => index !== _index);
    _fch = _fch.filter((value, index) => index !== _index);
    _b64 = _b64.filter((value, index) => index !== _index);
    console.log("setting fch to : ", _fch);
    setFch(_fch);
    setFiles(_values);
    setB64Files(_b64);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    tabPanelRoot: {
      padding: 0,
    },
    panel: {
      width: "100%",
    },
    margin: {
      margin: theme.spacing(0),
    },
    withoutLabel: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },

    textField: {
      width: 300,
    },
  }));

  const classes = useStyles();
  return (
    <Card className="p-4 mb-4">
      {/* -------------------------------------- Fichiers ----------------------------------- */}
      <form id="file-form">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          alignContent="center"
          alignSelf="center"
          spacing={2}
          xs={12}
        >
          <Grid item xs={4}>
            {formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_typo_file_type",
            )}
          </Grid>
          <Grid item xs={2}>
            {formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_typo_load_file",
            )}
          </Grid>
          <Grid item xs={6}>
            {formatMessage(
              intl,
              "create_besc_maritime_import_accordion_files_typo_file_name",
            )}
          </Grid>

          {files.map((value, index) => {
            return (
              <>
                <Grid item xs={4}>
                  <FormControl
                    fullWidth
                    className={classes.margin}
                    variant="outlined"
                  >
                    <TextField
                      className="m-2"
                      size="small"
                      id="outlined-select-currency"
                      select
                      required
                      label={formatMessage(
                        intl,
                        "create_besc_maritime_import_accordion_files_typo_file_type",
                      )}
                      name="types"
                      value={value.types}
                      variant="outlined"
                      onChange={(event) => handleChange(index, event)}
                    >
                      {ftypes.map((option, ind) => (
                        <MenuItem
                          key={ind}
                          value={option.name}
                          style={
                            option.selected === "true" && value.types === ""
                              ? { display: "none" }
                              : {}
                          }
                        >
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>

                <FileUpload
                  fileSizeLimit={2 * 1048576}
                  name={"name"}
                  label={"Nom du fichier"}
                  id={"-pj-" + index}
                  index={index}
                  size={5}
                  required={true}
                  init={init[index]}
                  sendFile={(_file) => {
                    console.log("CALLED SENDFILE, SETTING FILE... ");
                    console.log("index : ", index);
                    setFile(_file);
                  }}
                  onChange={() => {
                    // console.log("changed");
                  }}
                />

                <Grid item xs={1}>
                  <IconButton
                    aria-label="delete"
                    onClick={() => removeFile(index)}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                </Grid>
              </>
            );
          })}
        </Grid>
      </form>
      <Button
        variant="contained"
        color="primary"
        onClick={addFile}
        hidden={!ftypes.find((el) => el.selected === "false")}
      >
        {formatMessage(
          intl,
          "create_besc_maritime_import_accordion_files_btn_add",
        )}
      </Button>
      {/* <IconButton aria-label="delete" onClick={addFile}>
        <AddIcon />
      </IconButton> */}
    </Card>
  );
}
